import React, { ComponentPropsWithRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faCaretRight } from "@fortawesome/pro-solid-svg-icons";

type PropType = ComponentPropsWithRef<"button">;

export const PrevButton: React.FC<PropType> = (props) => {
  const { ...restProps } = props;

  return (
    <button
      className="w-6 h-full bg-primary-50 group absolute top-0 left-0 -translate-x-full overflow-y-hidden z-10"
      type="button"
      {...restProps}
    >
      <div className="w-full h-full shadow-slider-btn flex justify-center items-center">
        <FontAwesomeIcon
          className="text-monochrome-600 group-disabled:text-monochrome-200"
          icon={faCaretLeft}
        />
      </div>
    </button>
  );
};

export const NextButton: React.FC<PropType> = (props) => {
  const { ...restProps } = props;

  return (
    <button
      className="w-6 h-full bg-primary-50 group absolute top-0 right-0 translate-x-full overflow-y-hidden z-10"
      type="button"
      {...restProps}
    >
      <div className="w-full h-full shadow-slider-btn flex justify-center items-center">
        <FontAwesomeIcon
          className="text-monochrome-600 group-disabled:text-monochrome-200"
          icon={faCaretRight}
        />
      </div>
    </button>
  );
};
